import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class Anchor extends React.PureComponent<Anchor.Props, Anchor.State> {
  public static sectionId = 'anchor2';
  
  public render(): JSX.Element {
    const { section } = this.props
    const { settings } = section
    if (!settings || settings.handle === '') {
      return <React.Fragment/>
    }
    
    return (
      <div id={settings.handle} data-anchor={settings.handle}></div>
    )
  }
}

export namespace Anchor {
  export type Options = ShopifyNext.Section<{
    handle: string;
  }>;
  export interface Props extends GlobalProps {
    section: Anchor.Options;
  }
  export interface State {}
}
